import * as end from '../../../constants/api'
import axios from 'axios'
// constants
import storageNames from '../../../constants/storageNames'
// utils
import clearCacheData from '../../../utils/clearCache'
import { logoutGigya } from '../../../utils/gigyaControls'
import { axiosInstance } from '../../../services/axios-instance'

// *nota: encodeURIComponent formatea el valor del correo por uno entendible en las urls
// Servicio para autenticación y gestión de usuario
const AuthService = {
	// Verificar si el usuario está logueado
	isLoggedIn: validateRegister => {
		const isRegistered = localStorage.getItem(storageNames.isUserRegistered) === 'true'
		const validLocalStorage =
			localStorage.getItem(storageNames.gigyaToken) !== null ||
			localStorage.getItem(storageNames.cognitoToken) !== null ||
			localStorage.getItem(storageNames.authToken) !== null

		return !validateRegister && validateRegister !== undefined
			? Boolean(validLocalStorage)
			: Boolean(validLocalStorage && isRegistered)
	},

	// Obtener el token Gigya
	getTokenGigya: ({ uid }) => {
		const storageUID = localStorage.getItem(storageNames.gigyaUID)
		return axios
			.post(
				`${process.env.REACT_APP_GIGYA_TOKEN}`,
				{ action: 'getJWT', UID: uid || storageUID },
				{
					headers: {
						Apikey: process.env.REACT_APP_TRANSVERSAL_APIKEY
					}
				}
			)
			.then(res => res.data)
	},

	// Obtener la información del usuario
	getUserInfo: ({ userId }) => {
		return axiosInstance.get(`${end.profile({ userId })}`).then(res => res.data)
	},

	// Obtener la información del usuario V2
	getUserInfoV2: ({ userId }) => {
		return axiosInstance.get(`${end.profile({ userId })}`).then(res => res.data)
	},

	// Validar el email
	getValidationEmail: email => {
		return axiosInstance.post(end.emailValidation, email).then(res => res.data)
	},

	// Cambiar la contraseña
	changePassword: payload => {
		return axiosInstance.post(end.changePassword, payload).then(res => res.data)
	},

	// Obtener el token de información
	getTokenInfo: () => {
		return JSON.parse(localStorage.getItem(storageNames.cognitoToken))
	},

	// Iniciar sesión
	login: ({ payload, userId }) => {
		payload = payload ? { ...payload, device: navigator.platform } : { device: navigator.platform }

		return axiosInstance.post(end.login({ userId }), payload).then(res => res.data, payload)
	},

	// Registrar un nuevo usuario
	registerUser: ({ payload }) => {
		return axiosInstance.post(end.newRegister, payload).then(res => res.data, payload)
	},

	// Autenticar al usuario
	authenticateUser: () => {
		return axiosInstance.post(end.authenticate).then(res => res.data)
	},

	// Cerrar sesión
	logout: async ({ noRedirect } = {}) => {
		const installedApp = localStorage.getItem(storageNames.isInstallApp) || false
		const isMigrate = localStorage.getItem(storageNames.isMigrate) === 'true' || false
		const tokenGigya = !!localStorage.getItem(storageNames.gigyaToken)
		const auditEvents = localStorage.getItem(storageNames.auditEvents)
			? JSON.parse(localStorage.getItem(storageNames.auditEvents))
			: false
		const flagFirstEntry = localStorage.getItem(storageNames.flagFirstEntry) || false

		tokenGigya && (await logoutGigya())

		// *note: In order to best use of CDC we suggest to don't delete the cookies while user is login and LoginOut
		clearCacheData()
		window.localStorage.clear()
		window.sessionStorage.clear()

		installedApp && localStorage.setItem(storageNames.isInstallApp, installedApp)
		isMigrate && localStorage.setItem(storageNames.isMigrate, 'true')
		auditEvents && localStorage.setItem(storageNames.auditEvents, JSON.stringify(auditEvents))
		flagFirstEntry && localStorage.setItem(storageNames.flagFirstEntry, flagFirstEntry)

		if (noRedirect) return

		const currentPath = window.location.href
		if (currentPath.includes('par-q-public')) return

		window.location.href = '/'
	},

	getAllPatients: ({ userId }) => {
		return axiosInstance.get(end.patient({ userId })).then(res => res.data)
	},

	caregiverAddPatients: ({ userId, payload }) => {
		return axiosInstance.post(end.patient({ userId }), payload).then(res => res.data, payload)
	},

	setUserCIS: ({ userId, payload }) => {
		return axiosInstance.post(end.userCIS({ userId }), payload).then(res => res.data)
	},

	getShortCuts: ({ email }) => {
		const routeEmail = email ? `?email=${encodeURIComponent(email)}` : ''
		return axiosInstance.get(end.shortcuts + routeEmail).then(res => res.data)
	}
}

export default AuthService
